/**
 * Versão standalone do `translateTA`, para os renderers.
 *
 * O pipe original (`system-utils/pipes/translateTA.ts`) é `standalone: false` —
 * está declarado em vários NgModules — e por isso não entra no `imports` de um
 * componente standalone. Este aqui existe só para essa ponte: a REGRA é a mesma
 * função (`translateTAValue`), não uma cópia, então maiúscula no ID e devolver a
 * própria chave quando não encontra continuam sendo comportamento único.
 *
 * `pure: false` pelo mesmo motivo do original: o idioma muda em runtime, sem
 * recriar os componentes.
 */
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { translateTAValue } from '../../system-utils/pipes/translateTA';

@Pipe({
  name: 'translateTA',
  standalone: true,
  pure: false
})
export class TranslateTAPipe implements PipeTransform {

  constructor(private readonly translate: TranslateService) { }

  transform(key: string, params?: object): string {
    return translateTAValue(this.translate, key, params);
  }
}
